import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'

import useNotFound from 'services/gtm/useNotFound'
import './Page404.scss'

const Page404 = () => {
    const intl = useIntl()
    const backToCinestarWeb = () => {
        let referer = localStorage.getItem('referer')
        if (!referer || referer === 'undefined') {
            referer = `https://${process.env.REACT_APP_WEB_PORTAL_URL}`
        }
        window.location.href = referer
    }

    useNotFound()

    return (
        <Container fluid className="page-404 h-100 d-flex flex-column justify-content-center align-items-center px-3">
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'page404.pageTitle' })}
            </Typography>
            <ErrorWindow
                title={intl.formatMessage({ id: 'page404.title' })}
                description={intl.formatMessage({ id: 'page404.description' })}
                textButton1={intl.formatMessage({ id: 'page404.button' })}
                onClickButton1={() => backToCinestarWeb()}
            />
        </Container>
    )
}

export default Page404
